module.exports = __webpack_public_path__ + "img/0.d88d486d.png";